/** Filters out null and undefined values from a list with typing assertions. */
export function existsFilter<T>(value: T | undefined | null): value is T {
  return value !== undefined && value !== null;
}
